import { ArticleSearchItem } from '@web/newsfeed/ArticleSearch/ArticleSearchItem/ArticleSearchItem';
import { ArticleSearchSkeleton } from '@web/newsfeed/ArticleSearch/ArticleSearchSkeleton/ArticleSearchSkeleton';
import { ArticleSearchHeader } from '@web/newsfeed/ArticleSearch/ArticleSearchHeader/ArticleSearchHeader';
import { useGetArticleSearchResults } from '@web/newsfeed/ArticleSearch/ArticleSearchList/articleSearchList.hooks';
import { EmptySearchResults } from '@web/components/EmptySearchResults/EmptySearchResults';
import { EmptySearchWrapper } from '@web/newsfeed/ArticleSearch/ArticleSearchList/articleSearchList.styles';
import { LoadMoreButton } from '@web/newsfeed/LoadMoreButton/LoadMoreButton';

export const ArticleSearchList = () => {
  const {
    data: searchResults,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useGetArticleSearchResults();
  const isLoadingResults = isLoading || isFetchingNextPage;
  const results = searchResults?.pages.flat();

  if (!results?.length && !isLoadingResults) {
    return (
      <EmptySearchWrapper>
        <EmptySearchResults mTop={120} />
      </EmptySearchWrapper>
    );
  }

  return (
    <>
      <ArticleSearchHeader />
      {results?.map((article, index) => (
        <ArticleSearchItem article={article} key={index} />
      ))}
      {isLoadingResults && <ArticleSearchSkeleton />}
      <LoadMoreButton
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </>
  );
};
